import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { processReq } from "../../helpers/processRequest";
import { GET, POST, PUT } from "../../utils/requestActionConstants";
import { API_ROUTE } from "../../utils/commonConstants";

const init = {
    category: {},
    categoryList: [],
    loading: {},
    error: null
};

export const categorySlice = createSlice({
    name: "categorySlice",
    initialState: init,
    reducers: {
        setCategory: (state, action) => {
            state.category = action.payload;
        },

        setCategories: (state, action) => {
            state.categoryList = action.payload;
        },

        clearData: (state) => {
            return init;
        },
    },
    extraReducers: (builder) => {
        builder
        // Fetch data list
        .addCase(fetchCategoryList.pending, (state) => {
            state.loading.fetching = true;
            state.error = null;
        })
        .addCase(fetchCategoryList.fulfilled, (state, action) => {
            state.loading.fetching = false;
            state.categoryList = action.payload;
        })
        .addCase(fetchCategoryList.rejected, (state, action) => {
            state.loading.fetching = false;
            state.error = action.payload;
        })

        // Add category
        .addCase(addCategory.pending, (state) => {
            state.loading.saving = true;
            state.error = null;
        })
        .addCase(addCategory.fulfilled, (state, action) => {
            state.loading.saving = false;
            state.category = action.payload;
        })
        .addCase(addCategory.rejected, (state, action) => {
            state.loading.saving = false;
            state.error = action.payload;
        })

        // Update category
        .addCase(updateCategory.pending, (state) => {
            state.loading.saving = true;
            state.error = null;
        })
        .addCase(updateCategory.fulfilled, (state, action) => {
            state.loading.saving = false;
            state.category = action.payload;
        })
        .addCase(updateCategory.rejected, (state, action) => {
            state.loading.saving = false;
            state.error = action.payload;
        });;
    }
});

export const fetchCategoryList = createAsyncThunk(
    "productSlice/fetchCategoryList",
    async (_, { rejectWithValue }) => {
        try {
            const response = await processReq(GET, `${API_ROUTE}/categories`);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || "Failed to fetch data");
        }
    }
);

export const updateCategory = createAsyncThunk(
    "categorySlice/updateCategory",
    async ({ categoryId, categoryData }, { rejectWithValue, dispatch }) => {
        try {
            const response = await processReq(PUT, `${API_ROUTE}/categories/${categoryId}`, categoryData);
            dispatch(fetchCategoryList());
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || "Failed to update category");
        }
    }
);

export const addCategory = createAsyncThunk(
    "categorySlice/addCategory",
    async ({ categoryData }, { rejectWithValue, dispatch }) => {
        try {
            const response = await processReq(POST, `${API_ROUTE}/categories`, categoryData);
            dispatch(fetchCategoryList());
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || "Failed to add category");
        }
    }
);

export const { clearData, setCategory, setCategories } = categorySlice.actions;

export default categorySlice.reducer;
